/**
 * Query used to get audit records of provided RFXRequest.
 * Below are the list of services that it talks to:
 * AWSSCMRFXService
 */
import { gql } from '@apollo/client';

import { processResponse } from './helper';

export const getRFXRequestAuditRecordsQuery = gql`
  query getRFXRequestAuditRecords($rfxRequestRevisionedId: RFXRevisionedIdInput!) {
    getRFXRequestAuditRecords(rfxRequestRevisionedId: $rfxRequestRevisionedId) {
      rfxRequestAuditRecords {
        rfxRequestRevisionedId {
          id {
            value
          }
          revision
        }
        rfxRequestVersion
        timeStamp
        requestActor
        requestSource
        attribute
        prev
        next
        lifeCycleState
      }
    }
  }
`;

export default function getRFXRequestAuditRecords(this: any, request: any) {
  return processResponse(
    this.query({
      query: getRFXRequestAuditRecordsQuery,
      variables: request,
      fetchPolicy: 'network-only'
    }),
    'getRFXRequestAuditRecords'
  );
}
